import { Injectable } from '@angular/core';
import { BehaviorSubject, type Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class GuardsContextService {
  private readonly isProcessingAuthSubject$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

  getIsProcessingAuth$(): Observable<boolean> {
    return this.isProcessingAuthSubject$.asObservable();
  }

  setIsProcessingAuth(isProcessingAuth: boolean): void {
    this.isProcessingAuthSubject$.next(isProcessingAuth);
  }
}
